import React from 'react';

export default function BlockerMiddleImage({middleImageClass, middleImageHtml}) {
  if(middleImageClass) {
    return <div className={`middle-image ${middleImageClass}`}></div>;
  } else if (middleImageHtml) {
    return (
      <div
        className="middle-image"
        dangerouslySetInnerHTML={{__html: middleImageHtml}}>
      </div>
    )
  } else {
    return null;
  }
};
